import { css } from '@lastbrand/web-ui-styled-system/css'

// Panda twin of productInfo.module.scss; legacy is fluid-rem (~10px root), sizes mapped by intended px.

export const containerCss = css({
  width: 'inherit',
})

// The margin variants below are mutually exclusive (picked in product-info-ds.tsx);
// stacking them as overrides is unreliable because Panda emits one class per
// property value and their stylesheet order is not the cx() order.
export const containerSpacingCss = css({
  mb: 'space-20',
})

export const containerUpdatedDesignV2Css = css({
  mb: 'space-24',
})

export const containerThirdPartyCss = css({
  mb: 'space-20',
})

export const containerNewDesignV2BundleCss = css({
  mb: 0,
})

export const containerBrandNameCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  color: 'mediumgray',
  mb: { base: 'space-10', lg: 'space-4' },
  borderBottom: '1px solid transparent',
  display: 'inline-block',
  _hover: {
    color: 'black',
    borderBottom: '1px solid token(colors.black)',
  },
})

export const containerBrandNameNewDesignV2Css = css({
  // mobile-only overrides; lg restores the base brand-name desktop values (lg: undefined would not reset base).
  lineHeight: { base: '16px', lg: '18px' },
  letterSpacing: { base: '0.6px', lg: '1.5px' },
  mb: { base: 'space-6', lg: 'space-4' },
  border: { base: 'none', lg: '1px solid transparent' },
})

export const containerBrandNameWithoutLinkCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  color: 'mediumgray',
  mb: { base: 'space-10', lg: 'space-4' },
  borderBottom: '1px solid transparent',
  display: 'inline-block',
})

export const containerBrandNameWithoutLinkNewDesignV2Css = css({
  // mobile-only overrides; lg restores the base brand-name desktop values (lg: undefined would not reset base).
  lineHeight: { base: '16px', lg: '18px' },
  letterSpacing: { base: '0.6px', lg: '1.5px' },
  mb: { base: 'space-4', lg: 'space-4' },
})

export const containerHeaderCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 'space-24',
  pb: 'space-12',
  // Fill the form column so the title stays on one line.
  width: 'full',
})

export const containerHeaderNewDesignV2Css = css({
  gap: 'space-16',
  pb: { base: 'space-12', lg: 'space-16' },
  width: { base: '100%', lg: undefined },
})

export const containerHeaderUpdatedDesignV2Css = css({
  pb: 'space-12',
})

// No textStyle here: `_adjustedPadding` (always applied) owns the font; a second textStyle
// races it by stylesheet source order (not cx order) and rendered the title serif/24px (wrapping).
export const containerHeaderTextCss = css({
  fontStyle: 'normal',
  fontWeight: 400,
  // Desktop sizes to content (flex-shrinks within the column) so the title stays on one line.
  width: { base: '316px', lg: 'auto' },
})

export const containerHeaderTextAdjustedPaddingCss = css({
  textStyle: { base: 'body-16', lg: 'body-20' },
  lineHeight: { base: '22px', lg: '24px' },
})

export const containerHeaderTextNewDesignV2Css = css({
  textStyle: { base: 'body-14', lg: undefined },
  // mobile-only cap; explicitly unset on desktop (`lg: undefined` would not reset base).
  maxWidth: { base: '220px', lg: 'none' },
  width: { base: 'auto', lg: undefined },
})

export const containerHeaderTextNewDesignV2ReviewSummaryNotVisibleCss = css({
  width: '100%',
  maxWidth: '100%',
})

export const containerHeaderIconCss = css({
  marginTop: 'space-4',
  cursor: 'pointer',
  display: { base: 'none', lg: 'block' },
})

export const reviewWrapperCss = css({
  display: 'flex',
  alignItems: 'center',
  mb: 'space-24',
  cursor: 'pointer',
})

export const reviewRatingCss = css({ position: 'relative' })

export const reviewStarIconCss = css({ height: '13px', width: '14px' })

export const reviewCountCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '2px',
  textTransform: 'uppercase',
  color: 'black', // DS black token is #21201F
  ml: 'space-4',
  '& span': {
    borderBottom: '1px solid token(colors.black)',
    display: 'inline-block',
    mb: '2px',
  },
})

export const reviewWrapperNewDesignV2Css = css({
  flexShrink: 0,
  mb: 0,
})

export const reviewWrapperUpdatedDesignV2Css = css({
  mb: 'space-20',
})

export const reviewRatingNewDesignV2Css = css({
  top: 0,
})

export const reviewCountNewDesignV2Css = css({
  fontSize: { base: '11px', lg: undefined }, // no 11px DS token
  lineHeight: { base: '14px', lg: undefined },
  letterSpacing: { base: '0', lg: undefined },
})
